import { makeAutoObservable, observable } from "mobx";

export default class ExtraModel {
  constructor() {
    makeAutoObservable(this);
  }

  id = "";
  title = "";
  perPerson = "1";
  images = "";
  price_type = "";
  price = "";
  number_of_book = "";
  is_more_once_booking = "";

  cart = observable([]);

  current_people = 1;
  current_number_book = 1;
  personCalc = "1";
  loading = false;

  changeData = (k, v) => {
    this[k] = v;
  };

  get total() {
    if (this.price_type == "xperson") {
      this.personCalc =
        this.perPerson % this.current_people == 0
          ? 1
          : this.perPerson % this.current_people;
    } else {
      this.personCalc = this.current_people;
    }
    if (this.is_more_once_booking == 1) {
      return (
        parseFloat(this.personCalc) *
        parseFloat(this.current_number_book) *
        parseInt(this.price)
      );
    }

    return parseFloat(this.price) * parseInt(this.personCalc);
  }
}
